import React, { useState, useEffect } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom"
import './App.css';
import NotFound from './pages/NotFound'
import Contact from './pages/Contact'
import Connexion from './pages/Connexion'
import Recherche_new_v2 from "./pages/recherche_new_v2";
import Recherche_new_v3 from "./pages/recherche_new_v3";
import Recherche_new_v4 from "./pages/recherche_new_v4";
 
import Display_Partner_Catalog_DetailClass_new_v2 from "./pages/display_partner_catalog_detailclass_new_v2"
import Acceuil from "./pages/acceuil";


import RechecheArticles from "./pages/recherchearticles";
import AddArticle from "./pages/addarticle";

import ProduitsService from "./pages/produitservice";
import Recherche_new from "./pages/recherche_new";
import UserSignFirst from "./pages/usersigninfirst";

import SeDesabonner from './pages/sedesabonner';
import Training_Inactive_Or_Not_Found from "./pages/Traning_Inactif_Or_Not_Exist";
import Maintenance from "./pages/maintenance_page";

 

// New Design 2025
import New_Sign_In_2025 from "./pages/new_p_sign_in_2025";
import New_Sign_Up_2025 from "./pages/new_p_sign_up_2025";
import New_Tarif_2025 from "./pages/new_p_tarif_2025";
import New_Contact_2025 from "./pages/new_p_contact_2025";
import New_Article_Detail_2025 from "./pages/new_p_article_detail_2025";
import New_Formation_Detail_2025 from "./pages/new_p_detail_formation_2025";
import New_Marktplace_2025 from "./pages/new_p_marketplace_2025";


import New_A_Propos_2025 from "./pages/new_p_a_propos_2025";
import New_Home_Page_2025 from "./pages/new_p_home_page_2025";
import New_Fonctionnalite_2025 from "./pages/new_p_fonctionnalite_2025";

import New_Test_Header_Footer_2025 from "./pages/new_p_test_header_footer_2025";


function App() {

  const [screenSizeh, getDimension] = useState({
    dynamicWidth: window.innerHeight
  });


  const getSubdomain = url => {
    let domain = url;
    if (url.includes("://")) {
      domain = url.split('://')[1];
    }
    const subdomain = domain.split('.')[0];
    return subdomain;
  };


  useEffect(() => {

    let myurl = window.location.host;
    let myurl_pathname = window.location.pathname;



    var domain = myurl;
    if (domain.includes('://')) {
      domain = myurl.split('://')[1];
    }

    var tab_split = domain.split('.');

    const subdomain = domain.split('.')[0];

    var tab_reserved_subdomain = ['/dev', '/demo', 'demo', 'dev'];

    if (tab_split.length > 1 && myurl_pathname && !tab_reserved_subdomain.includes(subdomain)) {

      var tab_myurl_pathname = myurl_pathname.split('/');

      var tab_action = ['/moncatalog', '/Display-Partner-Catalog-Detail-formation', 'Display-Partner-Catalog-Detail-formation', 'moncatalog'];



      if (tab_myurl_pathname.length > 0 && !tab_action.includes(tab_myurl_pathname[1]) && !tab_reserved_subdomain.includes(subdomain)) {

        var new_url = window.location.protocol + "//" + domain.split('.')[0] + "." + domain.split('.')[1] + "/moncatalog";
      }


    }


  }, []);


  return (
    <div>
      <div className="App">
        {/*API DEV = {process.env.REACT_APP_API_URL_DEV} <br/>
    API REC = {process.env.REACT_APP_API_URL_REC}<br/>
    API URL = {process.env.REACT_APP_API_URL}<br/>
  */}


        <div className="main_haut">
          <BrowserRouter>
            <scrollToTop />
            <Switch>



              <Route path="/v3" exact component={Recherche_new_v3} />
              <Route path="/v4" exact component={Recherche_new_v4} />
              <Route path="/acceuil" exact component={Acceuil} />
              <Route path="/maintenance" exact component={Maintenance} />
              <Route path="/markeplace" exact component={Contact} />

              <Route path="/user-connexion" exact component={Connexion} />

              <Route path="/Display-Partner-Catalog-Detail-formation/:classId" exact component={Display_Partner_Catalog_DetailClass_new_v2} />
              <Route path="/Display-Partner-Catalog-Detail-formation/:classId/:action" exact component={Display_Partner_Catalog_DetailClass_new_v2} />

              {/* <Route path="/Produits-Services/" exact component={ProduitsService} />*/}
              <Route path="/Recherche_new/" exact component={Recherche_new} />
              <Route path="/Recherche_new/:type/:categorie" exact component={Recherche_new} />
              <Route path="/Connexion-utilisateur-0/" exact component={UserSignFirst} />
              <Route path="/Recherche_new_v2/" exact component={Recherche_new_v2} />
              <Route path="/Recherche_new_v2/:type/:categorie" exact component={Recherche_new_v2} />
              <Route path="/unsubscribe/" exact component={SeDesabonner} />
              <Route path="/page-inconnue/" exact component={NotFound} />
              <Route path="/formation-inconnue/" exact component={Training_Inactive_Or_Not_Found} />
              <Route path="/fonctionnalites/" exact component={New_Fonctionnalite_2025} />

              {/**** New design 2025 */}
              <Route path="/signin/" exact component={New_Sign_In_2025} />
              <Route path="/signup/" exact component={New_Sign_Up_2025} />
              <Route path="/tarif/" exact component={New_Tarif_2025} />
              <Route path="/contact/" exact component={New_Contact_2025} />

              {/*  
            
            09/03/25 : un redirection a été faite dans cloudflaire pour les lignes ci-dessous
            
              <Route path="/ContactezNous" exact component={New_Contact_2025} />

              */}



              <Route path="/display-detail-article/:articleId" exact component={New_Article_Detail_2025} />
              <Route path="/Display-Detail-Article/:articleId" exact component={New_Article_Detail_2025} />

              <Route path="/detaile-formation/:classId" exact component={New_Formation_Detail_2025} />
              {/* ex :  http://localhost:3009/detaile-formation/habilitation-electrique-882*/}

              <Route path="/marketplace/" exact component={New_Marktplace_2025} />

              <Route path="/apropos/" exact component={New_A_Propos_2025} />
              {/*  
            
            09/03/25 : un redirection a été faite dans cloudflaire pour les lignes ci-dessous
            <Route path="/QuiSommesNous" exact component={New_A_Propos_2025} />
              <Route path="/QuiSommesNous_v3" exact component={New_A_Propos_2025} />
              <Route path="/qui-sommes-nous" exact component={New_A_Propos_2025} />

              */}

              <Route path="/" exact component={New_Home_Page_2025} />



              {/* Debut Migration */}

              <Route path="/recherche-formation" exact component={New_Marktplace_2025} />
              <Route path="/recherche-formation/ref/:NewSearchText" exact component={New_Marktplace_2025} />
              <Route path="/mysy-training-login/:obj/:objid" exact component={New_Sign_In_2025} />
              <Route path="/Connexion" exact component={New_Sign_In_2025} />
              <Route path="/Recherche-Article-formation" exact component={RechecheArticles} />

              <Route path="/Display-Detail-formation_v3/:classId" exact component={New_Formation_Detail_2025} />
              <Route path="/Display-Detail-formation/:classId" exact component={New_Formation_Detail_2025} />
              <Route path="/Display-Detail-formation/:classId/:action" exact component={New_Formation_Detail_2025} />
              <Route path="/Display-Detail-formation_old/:classId/:action" exact component={New_Formation_Detail_2025} />
           
              <Route path="/Ajout-Article-formation" exact component={AddArticle} />


              {/* Fin Migration */}



              <Route path="/new_header_footer/" exact component={New_Test_Header_Footer_2025} />

              <Route component={NotFound} />
            </Switch>
          </BrowserRouter>
        </div>

      </div>


    </div>

  );
}


export default App;
